import gmx_zMixins         from '../../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_localData            from '../primitives/localData'
import lmx_Watching             from './Watching'
import lmx_Events               from './Events'

import lmx_LocalValues          from './set_LocalValues'
import lmx_draw_Forms           from './draw_Forms'
import lmx_draw_Summary         from './draw_Summary'

import lmx_draw_Timeline        from './draw_Timeline'
import lmx_draw_Skyline         from './draw_Skyline'
import lmx_draw_Legends         from './draw_Legends'
import lmx_draw_Detail          from './draw_Detail'
import lmx_draw_Excepts         from './draw_Excepts'

import lmx_PDF                  from './PDF'
import lmx_Search               from './Search'
import lmx_Refalsh              from './Refalsh'

export default {
  
  mixins: [
    gmx_zMixins, 
   
    // Local Mixins
    lmx_localData,
    lmx_Watching,
    lmx_Events,
    
    lmx_LocalValues,
    lmx_draw_Forms,
    lmx_draw_Summary,

    lmx_draw_Timeline,
    lmx_draw_Skyline,
    lmx_draw_Legends,
    lmx_draw_Detail,
    lmx_draw_Excepts,

    lmx_PDF,
    lmx_Search,
    lmx_Refalsh,

  ],

}
